import ErrorBoundary from 'components/error-boundaries';
import OpenPositions from 'modules/marketplace-performance-page/components/open-positions';
import ClosedPositions from 'modules/marketplace-performance-page/components/closed-positions';
import classNames from 'classnames';
import { useQueryParams } from 'modules/routing/useQueryParams';
import { useSchema } from 'modules/marketplace-performance-page/components/useSchema';
import Button from 'modules/shared-components/button/button';
import {
  ClosedPositionsStats,
  OpenPositionsStats,
} from 'api/types/httpsTypes/marketplace-performance';
import { formatTokenAmountCompact } from 'utils/FormatNumber';

interface Props {
  active: boolean;
  tabName: string;
  onClick: () => void;
}

function Tab({ active, tabName, onClick }: Props) {
  return (
    <Button
      id="about-tab"
      type="button"
      onClick={onClick}
      className={classNames(
        'xxs:py-4 border-none',
        active
          ? 'text-blue-500 underline'
          : 'text-black-900 dark:text-white-50 hover:text-black-700 dark:hover:text-white-500'
      )}
    >
      {tabName}
    </Button>
  );
}

interface DataProps {
  openPositionsStats: OpenPositionsStats;
  closedPositionsStats: ClosedPositionsStats;
}

const Positions = ({ openPositionsStats, closedPositionsStats }: DataProps) => {
  const [queryParams, setQueryParams] = useQueryParams(useSchema());
  const tabs = ['Open', 'Closed'];
  return (
    <ErrorBoundary>
      <div className="">
        <ul className="list-none flex flex-wrap lg:space-x-2 xxs:pl-0 mb-0 text-sm font-medium -ml-4">
          {tabs.map((tab) => (
            <li key={tab}>
              <Tab
                tabName={`${tab} (${
                  tab === 'Open'
                    ? formatTokenAmountCompact(
                        openPositionsStats?.overview?.numberPositions
                      )
                    : formatTokenAmountCompact(closedPositionsStats?.total)
                })`}
                active={tab === queryParams?.positionsActiveTab}
                onClick={() =>
                  setQueryParams({ ...queryParams, positionsActiveTab: tab })
                }
              />
            </li>
          ))}
        </ul>
        {queryParams.positionsActiveTab === 'Open' && (
          <OpenPositions openPositionsStats={openPositionsStats} />
        )}
        {queryParams.positionsActiveTab === 'Closed' && (
          <ClosedPositions closedPositionsStats={closedPositionsStats} />
        )}
      </div>
    </ErrorBoundary>
  );
};
export default Positions;
